<template>
  <div class="subscription-block">
    <subscribe
      :has-title="false"
      :is-standalone="true"
      :description-field="descriptionField"
      :cta-appearance="ctaAppearance"
    />
  </div>
</template>

<script>
import mapFields from '~/helpers/map-fields'
import Subscribe from '~/components/subscribe'

export default {
  name: 'SubscriptionBlock',

  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },

  components: {
    Subscribe
  },

  computed: {
    ...mapFields({
      descriptionField: 'description',
      ctaAppearance: 'ctaAppearance.value'
    })
  }
}
</script>

<style lang="scss" scoped>
.subscription-block {
  @include centered-50;
}
</style>
